// extracted by css-extract-rspack-plugin
export default {"errors":"G8bn3","icon":"Y6y2M"};